import * as actionTypes from "../ActionTypes";

/* SAVE */
export const saveResourceVideoRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.SAVE_RESOURCE_VIDEO_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const saveResourceVideoSuccess = (data) => ({
  type: actionTypes.SAVE_RESOURCE_VIDEO_SUCCESS,
  payload: data,
});

export const saveResourceVideoFailure = (error) => ({
  type: actionTypes.SAVE_RESOURCE_VIDEO_FAILURE,
  payload: error,
});

/* UPDATE */
export const updateResourceVideoRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.UPDATE_RESOURCE_VIDEO_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const updateResourceVideoSuccess = (data) => ({
  type: actionTypes.UPDATE_RESOURCE_VIDEO_SUCCESS,
  payload: data,
});

export const updateResourceVideoFailure = (error) => ({
  type: actionTypes.UPDATE_RESOURCE_VIDEO_FAILURE,
  payload: error,
});

/* DELETE */
export const deleteResourceVideoRequest = (payload, callback) => ({
  type: actionTypes.DELETE_RESOURCE_VIDEO_REQUEST,
  payload,
  callback,
});

export const deleteResourceVideoSuccess = (data) => ({
  type: actionTypes.DELETE_RESOURCE_VIDEO_SUCCESS,
  payload: data,
});

export const deleteResourceVideoFailure = (error) => ({
  type: actionTypes.DELETE_RESOURCE_VIDEO_FAILURE,
  payload: error,
});

/* READ */
export const readResourceVideoRequest = (payload, callback) => ({
  type: actionTypes.READ_RESOURCE_VIDEO_REQUEST,
  payload,
  callback,
});

export const readResourceVideoSuccess = (data) => ({
  type: actionTypes.READ_RESOURCE_VIDEO_SUCCESS,
  payload: data,
});

export const readResourceVideoFailure = (error) => ({
  type: actionTypes.READ_RESOURCE_VIDEO_FAILURE,
  payload: error,
});
